export default __webpack_public_path__ + "static/media/icons8-laugh-64.15f1f4a4.svg";